import { createI18n } from 'vue-i18n';

const messages = {
  en: {
    companyName: 'INTERACT',
    contact: 'Contact Us',
    realFeelAI: 'RealFeel AI <br> See and Feel the Intimacy',
    description: "RealFeel AI employs the eclusive video processing algorisms to control the toys, capable of delivering the best-in-class user experiences, make your dreams come true.",
    feature: "Features",
    watchVideo: "Player independent",
    videoType: "Any video in your phone storage, browser or 3rd-party Apps.",
    aiRecognition: "Scene Recognition",
    aiRecognitionDescription: "Exclusive algorithms knows what's happening in the video ...",
    motionTracking: "Behavior synchronization",
    motionTrackingDescription: "The toy moves according the commands (vibrate, etc,.) of our algorithms on the fly",
    coreBenefits: "Core Benefits",
    exclusiveAlgorithm: "Exclusive Algorithm",
    patentedTechnology: "Patented Technology",
    animeVideoSupport: "Anime Video Support",
    appServices: "APP Services",
    supportsMoreToys: "Supports More Toys",
    contactUs: "Contact Us",
  },
  jp: {
    companyName: 'あなたの会社',
    contact: 'お問い合わせ',
    realFeelAI: 'リアルフィールAI <br> 親密さを感じ、見る',
    description: 'RealFeel AI は独自のビデオ処理アルゴリズムを採用しておもちゃを制御し、最高クラスのユーザー体験を提供し、あなたの夢を実現します。',
    feature: "特徴",
    watchVideo: "プレイヤー独立",
    videoType: "あなたのスマートフォンのストレージ、ブラウザ、またはサードパーティ製アプリにあるどんなビデオでも。",
    aiRecognition: "シーン認識",
    aiRecognitionDescription: "独自のアルゴリズムがビデオの中で何が起こっているかを知っています...",
    motionTracking: "動作同期",
    motionTrackingDescription: "おもちゃは当社のアルゴリズムのコマンド（振動、など）に応じて即座に動きます。",
    coreBenefits: "コアの利点",
    exclusiveAlgorithm: "独自のアルゴリズム",
    patentedTechnology: "特許技術",
    animeVideoSupport: "アニメビデオサポート",
    appServices: "アプリサービス",
    supportsMoreToys: "より多くのおもちゃをサポート",
    contactUs: "お問い合わせ",
  },
};

const i18n = createI18n({
  locale: 'en', // 默认语言
  messages,
});

export default i18n;
